import(/* webpackMode: "eager", webpackExports: ["LegalDocPage"] */ "/app/src/components/LegalDocPage.tsx");
